import { render, staticRenderFns } from "./BuddleOrderBill.vue?vue&type=template&id=459618df&scoped=true"
import script from "./BuddleOrderBill.vue?vue&type=script&lang=js"
export * from "./BuddleOrderBill.vue?vue&type=script&lang=js"
import style0 from "./BuddleOrderBill.vue?vue&type=style&index=0&id=459618df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459618df",
  null
  
)

export default component.exports